import React from 'react';
import { Section } from './Section';
import { X } from 'lucide-react';
import { motion } from 'framer-motion';
const attempts = ['Los libros de autoayuda positiva te dicen que "vibrar alto" alejará a los manipuladores, pero solo te vuelven una presa más ingenua.', 'Tratar de razonar con personas oscuras solo les da más información sobre tus debilidades.', 'Ignorar los juegos de poder no hace que desaparezcan; solo hace que seas el único que no conoce las reglas del juego.', 'Intentar ser "demasiado bueno" es a menudo un mecanismo de defensa basado en el miedo, no en la virtud.'];
export function FailedAttempts() {
  return <Section className="max-w-5xl" data-id="element-55">
      <div className="flex flex-col md:flex-row gap-12 md:gap-20" data-id="element-56">
        <div className="md:w-1/3" data-id="element-57">
          <div className="sticky top-24" data-id="element-58">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-foreground" data-id="element-59">
              Por qué lo que has intentado no funciona
            </h2>
            <div className="h-[1px] w-12 bg-blood mb-6" data-id="element-60"></div>
            <p className="text-foreground/60 font-sans text-sm uppercase tracking-widest" data-id="element-61">
              La trampa de la bondad
            </p>
          </div>
        </div>

        <div className="md:w-2/3 space-y-6" data-id="element-62">
          {attempts.map((attempt, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="flex items-start gap-6 p-6 border border-border bg-dark/50" data-id="element-63">
              <div className="mt-1 flex-shrink-0" data-id="element-64">
                <X className="w-6 h-6 text-blood" strokeWidth={2.5} data-id="element-65" />
              </div>
              <p className="text-lg font-sans font-light text-foreground/80 leading-relaxed" data-id="element-66">
                {attempt}
              </p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}